import { AlertSeverity } from '@aloft/toolkit-shared';
import { Icon, IconName, ProductColor } from '@aloft/toolkit-sui';

const iconStyle = { flexShrink: 0, display: 'block' } as const;

export const AlertSeverityIcon = ({
  severity,
  variant = 'severity',
}: {
  severity: AlertSeverity;
  variant?: 'severity' | 'ai';
}) => {
  let icon: IconName = 'error-warning';
  let color: ProductColor = 'graphChart4';

  if (variant === 'ai') {
    icon = 'sparkle';
    color = 'alertAiIcon';
  } else if (severity === 'error') {
    icon = 'information-close';
    color = 'alertError';
  }

  return <Icon icon={icon} color={color} __styleDoNotUse={iconStyle} />;
};
